module.exports = __webpack_public_path__ + "static/media/Logo Pesta Literasi Indonesia.65406fee.png";